import './index.scss';

const heightPadding = 10

function setFrameHeight(element, height) {
    element.css('height', `${height + heightPadding}px`)
    element.addClass('auto-size')
}

$(function () {
    window.addEventListener('message', function (event) {
        if (event.origin.includes('eventbrite')) {
            console.log(event)

            if (event.data.messageName === 'widgetRenderComplete') {
                setFrameHeight($('div.ticket-shop-component iframe'), event.data.widgetHeight)
                setTimeout(() => $('div.ticket-shop-component').addClass('loaded'), 1000)
            }
        }
    })
})